export default __webpack_public_path__ + "static/Milford-Sound-credit-Joan-CampderrCanas-9b4b5bebaec780e2e25b946d3739dc8d.jpg";